module.exports = "https://www.gc-qa.gnp.com.mx/5f92d5827eef0c71c378045503fbe591.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-question.png
// module id = 327
// module chunks = 0